var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdnoklassnikiFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#ED812B"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.016 23.79c-1.55-.16-2.946-.538-4.142-1.464-.148-.115-.3-.226-.437-.355-.523-.496-.576-1.066-.162-1.654.355-.502.95-.636 1.568-.348.12.056.233.126.343.2 2.23 1.516 5.29 1.558 7.528.07.22-.17.458-.306.733-.376.534-.136 1.032.058 1.318.52.328.528.323 1.044-.08 1.454-.62.628-1.363 1.083-2.19 1.4-.78.3-1.637.45-2.485.55.128.14.188.207.268.286 1.15 1.145 2.307 2.284 3.454 3.432.39.39.472.876.257 1.33-.236.498-.763.825-1.28.79-.326-.023-.582-.184-.81-.41-.867-.864-1.75-1.713-2.602-2.594-.248-.257-.367-.208-.585.014-.874.89-1.762 1.767-2.655 2.638-.4.39-.878.462-1.343.238-.495-.237-.81-.736-.785-1.238.017-.34.186-.6.42-.832 1.14-1.125 2.275-2.253 3.41-3.38.077-.076.147-.155.256-.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.964 19.818c-2.686-.01-4.89-2.233-4.873-4.92A4.92 4.92 0 0 1 20.024 10c2.718.007 4.9 2.228 4.886 4.973-.015 2.68-2.233 4.854-4.946 4.845zm2.44-4.913a2.393 2.393 0 0 0-2.4-2.398 2.396 2.396 0 0 0-2.408 2.427 2.393 2.393 0 0 0 2.42 2.378 2.388 2.388 0 0 0 2.39-2.407z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdnoklassnikiFull);
export default __webpack_public_path__ + "static/media/odnoklassniki-full.c4df7f8dfe24aac81a64355327920e18.svg";
export { ForwardRef as ReactComponent };